import React from "react";
import { Outlet, Route } from "react-router-dom";
import AccountDetails from "../pages/AccountDetails/AccountDetails";
import Accounts from "../pages/Accounts/Accounts";
import Artists from "../pages/catalog/Artists/Artists";
import Composers from "../pages/catalog/Composers/Composers";
import Labels from "../pages/catalog/Labels/Labels";
import Lyricists from "../pages/catalog/Lyricists/Lyricists";
import Tracks from "../pages/catalog/Tracks/Tracks";
import Dashboard from "../pages/Dashboard/Dashboard";
import InvoiceDetails from "../pages/InvoiceDetails/InvoiceDetails";
import Invoices from "../pages/Invoices/Invoices";
import PaymentDetails from "../pages/PaymentDetails/PaymentDetails";
import Payments from "../pages/Payments/Payments";
import Income from "../pages/reports/Income/Income";
import SalesData from "../pages/SalesData/SalesData";
import Settings from "../pages/Settings/Settings";
import SignupRequests from "../pages/SignupRequests/SignupRequests";
import Users from "../pages/Users/Users";
import ROUTES from ".";
import Navbar from "../components/layout/Navbar";
import PrivateRoute from "./PrivateRoute";
import Platform from "../pages/Platform/Platform";
import Distributor from "../pages/Distributor/Distributor";

function AdminLayout() {
  return (
    <Navbar>
      <Outlet />
    </Navbar>
  );
}

const Admin = () => {
  return (
    <Route
      path={ROUTES.PATHS.ADMIN.HOME}
      element={
        <PrivateRoute>
          <AdminLayout />
        </PrivateRoute>
      }
    >
      <Route index element={<Dashboard />} />
      <Route path={ROUTES.PATHS.ADMIN.SALESDATA} element={<SalesData />} />
      <Route path={ROUTES.PATHS.ADMIN.TRACKS} element={<Tracks />} />
      <Route path={ROUTES.PATHS.ADMIN.LABELS} element={<Labels />} />
      <Route path={ROUTES.PATHS.ADMIN.ARTISTS} element={<Artists />} />
      <Route path={ROUTES.PATHS.ADMIN.LYRICISTS} element={<Lyricists />} />
      <Route path={ROUTES.PATHS.ADMIN.COMPOSERS} element={<Composers />} />
      <Route path={ROUTES.PATHS.ADMIN.DISTRIBUTOR} element={<Distributor />} />
      <Route path={ROUTES.PATHS.ADMIN.PLATFORM} element={<Platform />} />
      <Route path={ROUTES.PATHS.ADMIN.CLIENTS} element={<Accounts />} />
      <Route
        path={ROUTES.PATHS.ADMIN.CLIENT_DETAILS_ID}
        element={<AccountDetails />}
      />
      <Route path={ROUTES.PATHS.ADMIN.PAYMENTS} element={<Payments />} />
      <Route
        path={ROUTES.PATHS.ADMIN.PAYMENT_DETAILS_ID}
        element={<PaymentDetails />}
      />
      <Route path={ROUTES.PATHS.ADMIN.INVOICES} element={<Invoices />} />
      <Route
        path={ROUTES.PATHS.ADMIN.INVOICE_DETAILS_ID}
        element={<InvoiceDetails />}
      />
      <Route path={ROUTES.PATHS.ADMIN.INCOME} element={<Income />} />
      <Route
        path={ROUTES.PATHS.ADMIN.SIGNUP_REQUESTS}
        element={<SignupRequests />}
      />
      <Route path={ROUTES.PATHS.ADMIN.USERS} element={<Users />} />
      <Route path={ROUTES.PATHS.ADMIN.SETTINGS} element={<Settings />} />
    </Route>
  );
};

export default Admin;
